<template>
	<div class="footer-container">
		<div class="footer-content auth-container">
			<div>
				<a href="/">
					<img alt="Pixellot Logo" height="24" src="/my/images/pixellot-logo-white.png">
				</a>
			</div>
			<div>© Pixellot. {{ $tc('footer.rights') }}</div>
			<div>
				<a href="/my-pixellot/privacy-policy/" target="_blank">{{ $tc('footer.privacyPolicy') }}</a>
				<a class="pl-10 pr-10" href="/my-pixellot/terms-use/" target="_blank">{{ $tc('footer.terms') }}</a>
				<a href="/my-pixellot/accessibility" target="_blank">{{ $tc('footer.accessibility') }}</a>
			</div>
		</div>
	</div>
</template>

<script>

export default {
	name: 'PixellotFooter'
}
</script>

<style lang="scss">
	.footer-container {
		z-index: 10;
		position: relative;
		background-color: $dark;

		.footer-content {
			display: flex;
			align-items: center;
			justify-content: space-between;
			height: $footerHeight;
			padding: 20px 0 15px;
			font-size: 15px;
			color: #a4a4a4;

			a {
				color: #a4a4a4;
				transition: 0.3s color;

				&:hover {
					color: $white;
				}
			}

			@include respond-below(tablet) {
				flex-direction: column;
				justify-content: space-around;
			}
		}
	}
</style>
